module.exports = __webpack_public_path__ + "img/assistantAccount-crm-warp2-img7.26e82acc.png";